import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const ProductBasicInfoComponent = ({ Categories,productTypes, onInnerBasicFormChange, selectedProducts }: any) => (

    <><AccordionContainer
        child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
                <InputContainer
                    label="Name"
                    name="Name"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Name'

                        )
                    }}
                    type="text"
                    value={selectedProducts?.Name}
                />

                <InputContainer
                    label="Price"
                    name="Price"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'Price'

                        )
                    }}
                    type="number"
                    value={selectedProducts?.Price}
                />
                <InputContainer
                    label="Available"
                    name="IsAvailable"
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event,
                            'IsAvailable'
                        )
                    }}
                    type="checkbox"
                    value={selectedProducts?.IsAvailable}
                />
                <InputContainer

                    label="ProductType"
                    labelField="Name"
                    list={productTypes}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'LogisticsProductTypeId'

                        );
                    }}
                    optionName='Choose ProductType'
                    type="select"
                    value={selectedProducts?.LogisticsProductTypeId}
                    valueField="Id"
                />
                <InputContainer

                    label="Category"
                    labelField="Name"
                    list={Categories}
                    onValueChange={(event: any) => {
                        onInnerBasicFormChange(
                            event.target.value,
                            'LogisticsCategoryId'

                        );
                    }}
                    optionName='Choose Category'
                    type="select"
                    value={selectedProducts?.LogisticsCategoryId}
                    valueField="Id"
                />
<div className='col-span-full'>
        <InputContainer
        label="Description"
        onValueChange={(event: any) => {
          onInnerBasicFormChange(
            event.target.value,
            'Description'
          );
        } }
        type="text"
        value={selectedProducts?.Description} /></div>
            </div>
            
        }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
    />
    </>

)
export default ProductBasicInfoComponent;
